<template>
    <!-- 分页组件  
        hide-on-single-page -->
    <div class="pagination">
    <el-pagination
        class="pagination"
        v-model:current-page="localCurrentPage"
        v-model:page-size="localPageSize"
        :pager-count="pagerCount"
        :page-sizes="[10, 20, 50, 100, 400]"
        :background="true"
        layout="prev, pager, next, jumper, total, sizes"
        :total="total"
        :disabled="disabled"
        :size="paginationSize"
        @change="onChange"
    />
    </div>
</template>
<script>
export default {
    name: "Pagination",
    props: {
        total: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        paginationSize: {
            type: String,
            default: "default" // 可选值：default / small
        },
        disabled: {
            type: Boolean,
            default: false
        },
        pagerCount: {
            type: Number,
            default: 5
        },

    },
    data() {
        return {
            localCurrentPage: this.currentPage,
            localPageSize: this.pageSize
        };
    },
    methods: {
        onChange(currentPage,pageSize) {
            this.$emit("onChange", currentPage,pageSize);
        },
    }
};
</script>
<style scoped lang="scss">
.pagination{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding: 20px 0;
}
</style>